import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	getWeek,
	setCadence,
	skipCard,
	swapCard,
} from "../../api/commands/keepInTouch";
import { Cadence } from "../../api/schemas/records";
import * as Cards from "../../widgets/keepInTouchCards";
import * as Picker from "../../widgets/recordPicker";

export const Message = defineMessageUnion({
	CompletedFetchWeek: { generation: S.Number, result: getWeek.Result },
	GotCardMessage: { message: Cards.Message },
	CompletedSkip: {
		recordId: S.String,
		generation: S.Number,
		result: skipCard.Result,
	},
	CompletedSwap: {
		recordId: S.String,
		replacementId: S.NullOr(S.String),
		generation: S.Number,
		result: swapCard.Result,
	},
	/** Tracked row: a new cadence, or null to clear it. */
	ChangedCadence: { recordId: S.String, cadence: S.NullOr(Cadence) },
	/** Pause keeps the cadence (R8); unpause restores it. */
	ClickedPause: { recordId: S.String, cadence: S.NullOr(Cadence) },
	ClickedUnpause: { recordId: S.String, cadence: S.NullOr(Cadence) },
	CompletedSetCadence: {
		recordId: S.String,
		cadence: S.NullOr(Cadence),
		paused: S.Boolean,
		generation: S.Number,
		result: setCadence.Result,
	},
	// Swap picker
	ChangedSwapTarget: { recordId: S.String },
	GotPickerMessage: { message: Picker.Message },
	ClickedSwapIn: {},
	ClickedAddRecord: {},
	CompletedNavigate: {},
	CompletedTrack: {},
});
export type Message = typeof Message.Type;
